import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";
import { Send, Download } from "lucide-react";

export default function AdminSubscribers() {
  const [subs, setSubs] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/subscribers").then(r => setSubs(r.data)); }, []);

  const broadcast = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/admin/broadcast", { subject, body });
      toast.success(`Broadcast queued to ${r.data.sent} subscribers (MOCKED — add Resend key to send real)`);
      setSubject(""); setBody("");
    } catch (e) { toast.error(e.response?.data?.detail || "Broadcast failed"); }
    setBusy(false);
  };

  const exportCsv = async () => {
    const token = localStorage.getItem("aperture_token");
    const r = await fetch(`${API}/admin/subscribers/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers-page">
      <div className="eyebrow mb-2">Audience</div>
      <div className="flex items-end justify-between mb-10">
        <h1 className="aperture-h1 text-4xl">Subscribers.</h1>
        <button onClick={exportCsv} data-testid="admin-subs-export" className="inline-flex items-center gap-2 border border-navy text-navy px-4 py-2 text-xs uppercase tracking-widest hover:bg-navy hover:text-white transition-colors rounded-sm"><Download className="w-3.5 h-3.5"/>Export CSV</button>
      </div>

      <form onSubmit={broadcast} className="bg-white p-6 rounded-sm border mb-8" style={{ borderColor: "rgba(10,37,64,0.10)" }} data-testid="admin-broadcast-form">
        <div className="eyebrow mb-4">Broadcast · <span className="text-navy/50 normal-case tracking-normal">Resend is MOCKED — logs only</span></div>
        <input required placeholder="Subject" value={subject} onChange={(e)=>setSubject(e.target.value)} data-testid="broadcast-subject" className="w-full mb-3 px-4 py-3 border rounded-sm text-sm focus:outline-none focus:border-gold" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        <textarea required placeholder="Body" value={body} onChange={(e)=>setBody(e.target.value)} data-testid="broadcast-body" className="w-full min-h-32 px-4 py-3 border rounded-sm text-sm focus:outline-none focus:border-gold" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        <button disabled={busy} data-testid="broadcast-send" className="btn-primary mt-4 px-6 py-3 text-xs uppercase tracking-widest inline-flex items-center gap-2 rounded-sm"><Send className="w-3.5 h-3.5"/>{busy ? "…" : "Send Broadcast"}</button>
      </form>

      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Email","Source","Joined"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {subs.length === 0 && <tr><td colSpan="3" className="px-4 py-10 text-center text-navy/50">No subscribers yet.</td></tr>}
            {subs.map((s, i) => (
              <tr key={s.id || i} className="border-t" style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3">{s.email}</td>
                <td className="px-4 py-3 text-navy/60 text-xs uppercase tracking-widest">{s.source}</td>
                <td className="px-4 py-3 text-navy/60 text-xs">{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
